// import "@babel/polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router/index";
import axios from "axios";
import VueAxios from "vue-axios";
import VueJsonp from "vue-jsonp";
import VueSplit from "vue-split-panel";
import Vuex from "vuex";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueCookies from "vue-cookies";
import VueI18n from "vue-i18n";
import UniqueId from "vue-unique-id";

Vue.use(VueI18n);
Vue.use(VueCookies);
Vue.use(Vuex);
Vue.use(VueJsonp);
Vue.use(VueAxios, axios);
Vue.use(VueSplit);
Vue.use(UniqueId);

Vue.prototype.$forceCompute = function(
  computedName,
  forceUpdate /* default: true */
) {
  if (this._computedWatchers[computedName]) {
    this._computedWatchers[computedName].run();
    if (forceUpdate || typeof forceUpdate == "undefined") this.$forceUpdate();
  }
};

Vue.directive("focus", {
  // When the bound element is inserted into the DOM...
  inserted: function(el) {
    // Focus the element
    el.focus();
  },
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
Vue.prototype.$eventHub = new Vue();

var vm = new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

global.vm = vm;
